import { Stack } from '@mui/material';

import CopyToClipboardButton from '../buttons/copyToClipboardButton';

export default function CopyableCode({
  code,
  codeClassName,
}: {
  code: string;
  codeClassName?: string;
}) {
  return (
    <Stack direction='row' gap='8px' alignItems='start' className='w-full'>
      <code
        className={`p-[8px] bg-gray-100 text-black rounded-md break-pretty w-full whitespace-pre overflow-x-auto text-[14px] ${
          codeClassName ?? ''
        }`}
      >
        {code}
      </code>
      <CopyToClipboardButton textToCopy={code} />
    </Stack>
  );
}
